import apiClient from './apiClient';

const TempRegistrationService = {
  verify: async ({ email, token }) => {
    const { data } = await apiClient.post('/temp-registration/verify', { email, token });
    return data; // { email, can_register, message? }
  },
  register: async ({ email, token, password }) => {
    const { data } = await apiClient.post('/temp-registration/register', { email, token, password });
    return data; // { message, user_id }
  }
};

export default TempRegistrationService;





